export enum ModalSizes {
    XS = 'max-w-xs',
    SM = 'max-w-sm',
    MD = 'max-w-md',
    LG = 'max-w-lg',
    XL = 'max-w-xl',
    XXL = 'max-w-2xl',
    XXXL = 'max-w-3xl',
    XXXXL = 'max-w-4xl',
    XXXXXL = 'max-w-5xl',
}
